const validCharacters = [
  '~',
  '`',
  '!',
  '@',
  '#',
  '$',
  '%',
  '^',
  '&',
  '*',
  '(',
  ')',
  '_',
  '-',
  '+',
  '=',
  '{',
  '[',
  '}',
  ']',
  '|',
  '\\',
  ':',
  ';',
  "'",
  '"',
  '<',
  ',',
  '>',
  '.',
  '?',
  '/',
];

export default validCharacters;
